<div class="container-fluid p-0 about-fasinating-diamond-main-section">
  <div class="mobile_version-backbutton">
    <a class="mobile-header" onclick="history.back()">
      <span> <img src="../../../assets/images/tournament/backBtn.svg" alt=""> </span>Cookie Policy</a>
  </div>
    <div class="secure-shopping about-fasinating-diamond">
        <div class="container">
            <div [innerHTML]="cmsContentData" class="section-contain"></div>
        </div>
    </div>
</div>


<!-- <section class="find-partner-page">
    <div class="mobile_version-backbutton">
      <a class="mobile-header" onclick="history.back()">
        <span> <img src="../../../assets/images/tournament/backBtn.svg" alt=""> </span>Cookie Policy</a>
    </div>
    <div class="container">
      <div class="row">
       
        <div class="col-md-12 mobile_border_top">
          <div class="right-side-section col-md-12">
            <div class="right-top-bar">
              <div class="col-md-12">
                <div class="section-title-text text-center pt-4">
                    <h1 class="title">COOKIE POLICY</h1>
                </div>
              </div>

                    <div class="unique_heading">
                      <h3 class="sub-title mb-1 text-center">COOKIE POLICY</h3>
                    </div>

              <div class="prv_bg">
                  <div class="prv-2">
                    <h4>1. Cookie</h4>
                    <p>To improve the responsiveness of the sites for our users, we may use “cookies”, or similar electronic
                      tools to collect information to assign each visitor a unique, random number as a User Identification
                      (User ID) to understand the user’s individual interests using the Identified Computer. Unless you
                      voluntarily identify yourself (through registration, for example), we will have no way of knowing who
                      you are, even if we assign a cookie to your computer. The only personal information a cookie can
                      contain is information you supply (an example of this is when you ask for our Personalised Horoscope).
                      A cookie cannot read data off your hard drive. Our advertisers may also assign their own cookies to
                      your browser (if you click on their ads), a process that we do not control. Our web servers
                      automatically collect limited information about your computer’s connection to the Internet, including
                      your IP address, when you visit our site. (Your IP address is a number that lets computers attached to
                      the Internet know where to send you data — such as the web pages you view.) Your IP address does not
                      identify you personally. We use this information to deliver our web pages to you upon request, to
                      tailor our site to the interests of our users, to measure traffic within our site and let advertisers
                      know the geographic locations from where our visitors come.</p>
                  </div>
                  <div class="prv-2">
                    <h4>2. Our use of cookies</h4>
                    <p>In common with many other website operators, we use cookies on our website. We use them to enrich
                      your experience of using the website by allowing us to tailor what you see to what we have learned
                      about your preferences during your visits to the site. Our cookies are also used to enable us to
                      develop our website to reflect our customers interests by noting who has seen which pages, how
                      frequently particular pages are visited and determining the most popular areas of our website. We and
                      carefully selected third parties also use cookies to show you more relevant advertising online.</p>
                    <P>We also use cookies to ensure that our website remains secure and that requests for pages on the
                      website are coming from real humans are and not harmful, automated 'bots'. These cookies do not
                      collect or store any personal data or any information that could uniquely identify you as an
                      individual.</P>
                    <P>We may incorporate social plugins for various online social networks (e.g. Facebook, Twitter and
                      YouTube) into some pages on our website. These services may use their own cookies (third-party
                      cookies) to identify you and track information about your visit to our website.</P>
                  </div>
                  <div class="prv-2">
                    <h4>3. What is a cookie</h4>
                    <p>Information may be sent to your computer in the form of an Internet "cookie" to allow our servers to
                      monitor your requirements. The cookie is stored on your computer. Our server may request that your
                      computer return a cookie to it.</p>
                    <P>These return cookies do not contain any information supplied by you or any personally identifiable
                      information about you. However, we use cookies to keep track of any purchase you make of ITF products
                      and services.</P>
                    <P>Such measures are necessary to allow the ITF and its subsidiaries to measure the usability of the
                      systems, which will help to continually improve user experience of our websites. Your browser software
                      should however enable you to block cookies if you wish to. For more information about cookies, please
                      visit http://www.allaboutcookies.org/.</P>
                    <P>In general, we use the following types of cookie:</P>
                  </div>
                  <div class="prv-2">
                    <h4>4. Strictly necessary cookies</h4>
                    <p>These cookies are essential in order to enable you to move around the website and use its features,
                      such as accessing secure areas of the website. Without these cookies services you have asked for like
                      online purchases and e-billing, cannot be provided.</p>
                  </div>
                  <div class="prv-2">
                    <h4>5. Performance cookies</h4>
                    <p>These cookies collect information about how visitors use a website, for instance which pages visitors
                      go to most often, and if they get error messages from web pages. These cookies don't collect
                      information that identifies a visitor. All information these cookies collect is aggregated and
                      therefore anonymous. It is only used to improve how a website works.</p>
                  </div>
                  <div class="prv-2">
                    <h4>6. Functionality cookies</h4>
                    <p>These cookies collect information about how visitors use a website, for instance which pages visitors
                      go to most often, and if they get error messages from web pages. These cookies don't collect
                      information that identifies a visitor. All information these cookies collect is aggregated and
                      therefore anonymous. It is only used to improve how a website works.</p>
                  </div>
                  <div class="prv-2">
                    <h4>7. Google Analytics</h4>
                    <p>The ITF uses Google Analytics, a web analytics service provided by Google. Google Analytics collects
                      first party cookies, which are text files placed on your computer to collect standard internet log
                      information and visitor behaviour. This information is sent to Google and is used to evaluate how our
                      website is being used. This enables us to compile statistical reports. A full list of cookies used by
                      Google Analytics and explanations on how these work are available on the Google code website.</p>
                    <P>The ITF does not collect (nor allow any third party to collect) personally identifiable information
                      of visitors to our site. We will not associate any data gathered with any personally identifying
                      information. We will not link or seek to link an IP address with the identity of a computer user. In
                      short, Google Analytics doesn't identify who you are, but it does track your movements on our
                      websites.</P>
                  </div>
                  <div class="prv-2">
                    <h4>8. How to disable cookies</h4>
                    <p>You can stop cookies being downloaded on to your computer by selecting the appropriate settings on
                      your browser. However please note that if you do this you may not be able to use the full
                      functionality of this website. </p>
                  </div>
              </div>

            </div>

          </div>
        </div>

      </div>
    </div>
  </section> -->